<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M16.25,24c-0.2,0-0.389-0.078-0.53-0.22L5,13.06c-0.283-0.283-0.439-0.659-0.439-1.059c0-0.4,0.155-0.777,0.438-1.06
		L15.72,0.22C15.861,0.078,16.05,0,16.25,0s0.389,0.078,0.53,0.22C16.922,0.361,17,0.55,17,0.75s-0.078,0.389-0.22,0.53L6.06,12
		L16.78,22.72c0.142,0.142,0.22,0.33,0.22,0.53s-0.078,0.389-0.22,0.53S16.45,24,16.25,24z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'arrow-left-1',
    },
    name: {
      type: String,
      required: false,
      default: 'ArrowLeft1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>